module.exports = __webpack_public_path__ + "static/favicon-c5ffcb6f6b4f8711fafa42328c2bfa8d.ico";